import React from "react";
import Jumbotron from "react-bootstrap/Jumbotron";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./contact-form.styles.css";

const ContactForm = () => {
  return (
    <div>
      <h1 className="pt-3 text-center font-details-b pb-3">CONTACT ME</h1>
      <Jumbotron className="contact-jumbotron">
        <Row className="d-flex justify-content-center">
          <Col className="d-flex justify-content-center align-self-center flex-wrap">
            <div className="m-2">
              <a href="mailto:shivavishwakarma7781@gmail.com" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-danger" title="shivavishwakarma7781@gmail.com">
                  <i className="fas fa-envelope-square"></i> Email Me
                </Button>
              </a>
            </div>

            <div className="m-2">
              <a href="https://github.com/Shiva7781" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-dark" title="My other projects">
                  <i className="fab fa-github-square"></i> GitHub
                </Button>
              </a>
            </div>

            <div className="m-2">
              <a href="https://www.linkedin.com/in/shivanand-vishwakarma/" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-primary" title="Visit my LinkedIn">
                  <i className="fab fa-linkedin"></i> LinkedIn
                </Button>
              </a>
            </div>

            <div className="m-2">
              <a href="https://medium.com/@shivavishwakarma7781" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-dark" title="My blogs">
                  <i className="fab fa-medium"></i> Medium
                </Button>
              </a>
            </div>

            <div className="m-2">
              <a href="https://api.whatsapp.com/send/?phone=917276508139&text&app_absent=0" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-success" title="Hello What's Up!">
                  <i className="fab fa-whatsapp-square"></i> WhatsApp
                </Button>
              </a>
            </div>
          </Col>
        </Row>

      </Jumbotron>
    </div>
  );
};

export default ContactForm;
